import * as React from "react";
const SvgPlayerJoined = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	id: "Toys-Rocking-Horse-1--Streamline-Streamline-3.0",
	...props
}, /* @__PURE__ */ React.createElement("desc", null, "\n		Toys Rocking Horse 1 Streamline Icon: https://streamlinehq.com\n	"), /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	d: "M17.884 10.419c1.364 1.246 3.509 2.794 5.366 2.33",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	d: "M21.238 17.249a9.02 9.02 0 0 0 -2.7 -3.895A1.5 1.5 0 0 1 18 12.205v-0.956a3 3 0 0 0 -3 -3h-3.894a1.5 1.5 0 0 1 -1.384 -0.924L7.558 2.133A1.5 1.5 0 0 0 5.6 1.325L2.135 2.768a2.25 2.25 0 0 0 1.731 4.154 0.75 0.75 0 0 1 0.981 0.4c0.479 1.151 1.442 3.463 2 4.791a1.5 1.5 0 0 1 -0.347 1.66 9.007 9.007 0 0 0 -2.238 3.475l2.875 1.5a6.751 6.751 0 0 1 11.226 0l2.875 -1.499Z",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	d: "M6.043 1.215C8.074 0.263 9.919 0.855 10.5 2.249l3 6",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	d: "M15.75 8.343v2.906a1.5 1.5 0 0 1 -1.5 1.5h-1.5a1.5 1.5 0 0 1 -1.5 -1.5v-3",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	d: "M10.5 20.248H15",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	d: "M10.5 23.248H15",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	d: "M5.25 4.624a0.375 0.375 0 1 1 0 -0.75",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	d: "M5.25 4.624a0.375 0.375 0 1 0 0 -0.75",
	strokeWidth: 1.5
}));
export { SvgPlayerJoined as ReactComponent };
